import api from "./api";
import type {
  IFinanceiroListResponse,
  IFinanceiroResumoResponse,
  OrigemLancamentoFinanceiro,
  StatusLancamentoFinanceiro,
  TipoLancamentoFinanceiro,
} from "interfaces/loja/financeiro";

/** GET /loja/financeiro/lancamentos */
export async function listarLancamentosFinanceiro(params?: {
  page?: number;
  limit?: number;
  tipo?: TipoLancamentoFinanceiro;
  status?: StatusLancamentoFinanceiro;
  origem?: OrigemLancamentoFinanceiro;
  pedidoId?: string;
  pagamentoId?: string;
  dataInicio?: string;
  dataFim?: string;
}) {
  const search = new URLSearchParams();
  if (params?.page != null) search.set("page", String(params.page));
  if (params?.limit != null) search.set("limit", String(params.limit));
  if (params?.tipo) search.set("tipo", params.tipo);
  if (params?.status) search.set("status", params.status);
  if (params?.origem) search.set("origem", params.origem);
  if (params?.pedidoId?.trim()) search.set("pedidoId", params.pedidoId.trim());
  if (params?.pagamentoId?.trim()) {
    search.set("pagamentoId", params.pagamentoId.trim());
  }
  if (params?.dataInicio) search.set("dataInicio", params.dataInicio);
  if (params?.dataFim) search.set("dataFim", params.dataFim);

  const qs = search.toString();
  const { data, status } = await api.get<IFinanceiroListResponse>(
    `/loja/financeiro/lancamentos${qs ? `?${qs}` : ""}`
  );
  return { data, status } as {
    data: IFinanceiroListResponse;
    status: number;
  };
}

/** GET /loja/financeiro/resumo */
export async function obterResumoFinanceiro(params?: {
  dataInicio?: string;
  dataFim?: string;
}) {
  const search = new URLSearchParams();
  if (params?.dataInicio) search.set("dataInicio", params.dataInicio);
  if (params?.dataFim) search.set("dataFim", params.dataFim);
  const qs = search.toString();
  const { data, status } = await api.get<IFinanceiroResumoResponse>(
    `/loja/financeiro/resumo${qs ? `?${qs}` : ""}`
  );
  return { data, status } as {
    data: IFinanceiroResumoResponse;
    status: number;
  };
}
